<template>
  <div class="e-diagram-wrap">
    <!--E表考试----单题组件-->

    <div class="main-area">

      <div class="do-bt">
        <el-button
            v-if="!isExercise"
            type="primary"
            size="small"
            @click="handleWps">在线表格
        </el-button>

        <template v-else>
          <div style="display: flex;align-items: center;">
            <el-button
                type="primary"
                size="small"
                style="margin-right: 10px;"
                @click="downAns"
            >下载题目表格
            </el-button>

            <el-upload
                ref="uploadRef"
                accept=".xlsx, .xls"
                action="aaa"
                :http-request="choiceFile"
                :show-file-list="false"
            >
              <template #trigger>
                <el-button
                    type="primary"
                    size="small"
                    icon="Upload"
                >上传答题表格
                </el-button>
              </template>
            </el-upload>
          </div>
        </template>
      </div>
    </div>

    <wps-dialog
        v-model:visible="editWpsVis"
        :current-row="currentQa"
        @saved="emit('save')"
    />
  </div>
</template>

<script setup>
import ViewRichText from "@/components/RichText/ViewRichText.vue";
import {clearExcelUrl, findTopicUrl} from "@/api/examCenter/exam";
import WpsDialog from "@/views/examCenter/eDiagram/wpsDialog.vue";
import {ElMessage, ElMessageBox} from "element-plus";
import request from "@/utils/request";

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
  isExercise: { // 是否为练习
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['error', 'loading', 'save', 'update:currentQa'])

const editWpsVis = ref(false)

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getData = () => {
  return {}
}
getGrandchildValue.value.getResetData = () => {
  emit('loading', true)
  clearExcelUrl({
    examStuInfoId: props.currentQa.examStuInfoId,
    queId: props.currentQa.queId,
  })
      .then(res => {
        emit('loading', false)

        Object.assign(props.currentQa, {
          fileUrl: null
        }); // 更新当前题目对象
       /* emit('update:currentQa', )*/
      })
      .catch(err => {
        emit('loading', false)
        emit('error', err)
      })

  return {}
}

async function handleWps() {
  if (props.currentQa.fileUrl) { // 有文件url，说明已经生成过了，则不再生成，直接打开wps
    editWpsVis.value = true
    return
  }
  emit('loading', true)
  findTopicUrl({
    examStudentInfoId: props.currentQa.examStuInfoId,
    queId: props.currentQa.queId,
  })
      .then(res => {
        emit('loading', false)

        Object.assign(props.currentQa, {
          fileUrl: res.data
        }); // 更新当前题目对象
        /* emit('update:currentQa', )*/
        editWpsVis.value = true
      })
      .catch(err => {
        emit('loading', false)
        emit('error', err)
      })
}

function downAns() {
  emit('loading', true)
  findTopicUrl({
    examStudentInfoId: props.currentQa.examStuInfoId,
    queId: props.currentQa.queId,
  })
      .then(res => {
        emit('loading', false)
        if (!res.data) {
          ElMessage.error('下载失败')
          return
        }
        const a = document.createElement('a')
        a.setAttribute('target', '_blank')
        a.setAttribute('href', res.data)
        a.setAttribute('style', 'display:none')
        document.body.appendChild(a)
        a.click()
        a.parentNode.removeChild(a)
      })
      .catch(err => {
        emit('loading', false)
        emit('error', err)
      })
}

const choiceFileName = ref('')
const currentFormData = ref(null)

function choiceFile(params) {
  const maxFileSize = 10 // 最大上传10M
  if (params.file.size > maxFileSize * 1024 * 1024) {
    ElMessage.error(`文件太大，最大支持${maxFileSize}M!`)
    return
  }
  const fileSuffix = params.file.name.substring(params.file.name.lastIndexOf('.'))
  if (!['.xls', '.xlsx'].includes(fileSuffix)) {
    ElMessage.error('文件类型错误，只能上传Excel格式文件!')
    return
  }
  const formData = new FormData()
  formData.append('file', params.file)
  formData.append('examStudentInfoId', props.currentQa.examStuInfoId)
  formData.append('queId', props.currentQa.queId)
  choiceFileName.value = params.file.name
  currentFormData.value = formData

  emit('loading', true)
  request({
    url: '/system/exam/uploadESheetFile',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: currentFormData.value,
    timeout: 60 * 1000
  })
      .then(res => {
          ElMessageBox.alert('上传成功', '提示', {
              confirmButtonText: 'OK',
              callback: () => {
              },
          })
      })
      .catch(() => {
      })
      .finally(() => {
        emit('loading', false)
      })
}
</script>


<style scoped lang="scss">
.e-diagram-wrap {
  padding: 10px;

  .qa-content {
    color: #333333;
    font-size: 14px;
    line-height: 22px;
  }

  .main-area {
    .rich-text {
      max-height: calc(100% - 40px);
      overflow-y: auto;
    }

    .do-bt {
      height: 32px;
      padding-top: 8px;
    }
  }


}
</style>
